'use client';

import RichText from 'molecules/RichText';

import styles from 'components/TextSection/textSection.module.scss';

import type { TextSectionProps } from 'components/TextSection/config';
import type { FC } from 'react';

const FooterNotes: FC<TextSectionProps> = ({ content, backgroundColor = 'gray' }) => (
  <section className={styles[backgroundColor]}>
    <div className={styles.container}>
      {content && (
        <div className={styles.content}>
          <RichText content={content} />
        </div>
      )}
    </div>
  </section>
);

export default FooterNotes;
